import { isAxiosError } from 'axios'
import type { TFunction } from 'i18next'

const HAZARD_NOT_PENDING_REVIEW_MESSAGE = 'Hazard is not pending review'

function readApiResponseMessage(data: unknown): string | undefined {
  if (!data || typeof data !== 'object') {
    return undefined
  }
  const message = (data as { message?: unknown }).message
  return typeof message === 'string' && message.trim().length > 0
    ? message
    : undefined
}

export function isHazardUncertainReview(
  uncertain: boolean | null | undefined
): boolean {
  return uncertain === true
}

export function resolveKeepUncertainErrorMessage(
  error: unknown,
  translate: TFunction<'machineryDirectiveCompliance'>
): string {
  if (isAxiosError(error)) {
    const responseMessage = readApiResponseMessage(error.response?.data)
    if (responseMessage === HAZARD_NOT_PENDING_REVIEW_MESSAGE) {
      return translate('hazardsPage.keepUncertainNotPending')
    }
    if (responseMessage != null) {
      return responseMessage
    }
    return translate('hazardsPage.keepUncertainFailed')
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message
  }
  return translate('hazardsPage.keepUncertainFailed')
}
